import { application } from "./application"
import MovementRowsController from "./movement_rows_controller"
import ZoneInventoryController from "./zone_inventory_controller"
import MovementValidationController from "./movement_validation_controller"
import RegisterDayValidationController from "./register_day_validation_controller"
import RegisterDayMovementInfoController from "./register_day_movement_info_controller"
import ModalController from "./modal_controller"
import ProcessAttachmentsController from "./process_attachments_controller"
import DeleteConfirmController from "./delete_confirm_controller"
import ReallocateConfirmController from "./reallocate_confirm_controller"
import ConfirmActionController from "./confirm_action_controller"
import DdtAnalyticalController from "./ddt_analytical_controller"
import EntityPickerController from "./entity_picker_controller"
import SubmitProgressController from "./submit_progress_controller"

console.log("[Controllers] Registering controllers...")
application.register("movement-rows", MovementRowsController)
application.register("zone-inventory", ZoneInventoryController)
application.register("movement-validation", MovementValidationController)
application.register("register-day-validation", RegisterDayValidationController)
application.register("register-day-movement-info", RegisterDayMovementInfoController)
application.register("modal", ModalController)
application.register("process-attachments", ProcessAttachmentsController)
application.register("delete-confirm", DeleteConfirmController)
application.register("reallocate-confirm", ReallocateConfirmController)
application.register("confirm-action", ConfirmActionController)
application.register("ddt-analytical", DdtAnalyticalController)
application.register("entity-picker", EntityPickerController)
application.register("submit-progress", SubmitProgressController)
console.log(
  "[Controllers] Controllers registered:",
  application.getControllerForElementAndIdentifier ? "Stimulus available" : "Stimulus not available"
)
